import { Result } from 'antd';
import styled from 'styled-components';

import { PageTitle } from 'components/PageTitle';

import { SUPPORT_EMAIL, SUPPORT_PHONE_NUMBER } from 'constants/all';

import StaticLayout from 'containers/Layouts/StaticLayout/StaticLayout';

const Email = styled.a`
  color: #5392f0;
  &:hover {
    text-decoration: underline;
  }
`;

const Wrapper = styled.main`
  margin-top: 50px;
  font-size: 18px;
  text-align: center;
`;

export const PaymentRequired = () => {
  return (
    <StaticLayout showHeader={true}>
      <PageTitle title="Payment required" />
      <Wrapper>
        <Result
          status="warning"
          title="Your account is locked."
          extra={
            <span>
              Please contact us at{' '}
              <Email href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Email> or
              call {SUPPORT_PHONE_NUMBER}.
            </span>
          }
        />
      </Wrapper>
    </StaticLayout>
  );
};
